import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { BoardDetail, UUID } from "@/lib/types";

interface Vars {
  boardId: UUID;
  columnId: UUID;
}

export function useDeleteColumn() {
  const qc = useQueryClient();
  return useMutation<void, Error, Vars>({
    mutationFn: ({ columnId }) => api.deleteColumn(columnId),
    onSuccess: (_void, { boardId, columnId }) => {
      qc.setQueryData<BoardDetail>(queryKeys.board(boardId), (prev) =>
        prev
          ? {
              ...prev,
              columns: prev.columns.filter((c) => c.id !== columnId),
              rows: prev.rows.map((r) => ({
                ...r,
                cells: r.cells.filter((cell) => cell.column_def_id !== columnId),
              })),
            }
          : prev,
      );
      void qc.invalidateQueries({ queryKey: queryKeys.board(boardId) });
    },
  });
}
